import React, {useEffect, useState} from 'react'
import {useSnapEngage} from '../../custom-api/hooks/use-snap-engage'
import {useCustomPreferenceWithLocale} from '../../hooks/use-custom-preference'
import {useLocation} from 'react-router-dom'
import {Global, css} from '@emotion/react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'

const HIDE_CSS = css`
    #designstudio-button {
        display: none !important;
    }
`

const SnapEngage = () => {
    const location = useLocation()
    const {data: customer} = useCurrentCustomer()
    const snapEngageConfig = useCustomPreferenceWithLocale('snapEngageConfiguration')
    const snapEngageWidgetID = snapEngageConfig?.snapEngageWidgetID || ''
    const proactiveChat =
        snapEngageConfig?.proactiveChat === 'true' || snapEngageConfig?.proactiveChat === true

    let snapEngageURLExclusion = snapEngageConfig?.snapEngageURLExclusion || []

    const [hide, setHide] = useState(false)

    useEffect(() => {
        let interval = null

        function registerCallbacks() {
            if (window.SnapEngage && window.SnapEngage.setCallback) {
                ;['Open', 'Close'].forEach((event) => {
                    window.SnapEngage.setCallback(event, () => {
                        if (event === 'Open') {
                            window.SnapEngage.setCustomField('CRM_name', customer?.firstName || '')
                            window.SnapEngage.setCustomField(
                                'CRM_surname',
                                customer?.lastName || '',
                            )
                            window.SnapEngage.setUserEmail(customer?.email || '')
                        }
                        setHide(event === 'Open')
                    })
                })
                clearInterval(interval)
            }
        }

        registerCallbacks()
        interval = setInterval(registerCallbacks, 500)

        return () => clearInterval(interval)
    }, [customer])

    useSnapEngage({snapEngageWidgetID, proactiveChat})

    useEffect(() => {
        let shouldDisableChat = false

        for (let exclusion of snapEngageURLExclusion) {
            try {
                const regex = new RegExp(exclusion)
                if (regex.test(location.pathname)) {
                    shouldDisableChat = true
                    break
                }
            } catch (e) {
                if (location.pathname === exclusion) {
                    shouldDisableChat = true
                    break
                }
            }
        }
        if (window.SnapEngage) {
            window.SnapEngage.allowProactiveChat(!shouldDisableChat)
            shouldDisableChat ? window.SnapEngage.hideButton() : window.SnapEngage.showButton()
        }
    }, [location.pathname, snapEngageURLExclusion])

    return <>{hide && <Global styles={HIDE_CSS} />}</>
}

export default SnapEngage
